export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ORGANIZATION_AUTH = "setOrganizationAuth";
export const SWITCH_ORGANIZATION_USER_AUTH = "switchOrganizationUser";
export const SET_ERROR = "setError";
export const SKIP_CHANGE_PASSWORD = "skipChangePassword";
export const SET_USERS = "setUsers";
export const SKIP_GUIDE = "skipGuide";
export const UPDATE_GUIDE_STEP = "updateGuideStep";
export const UPDATE_STRIPE_STATUS = "updateStripeStatus";
export const SET_PLAN_STATUS = "setPlanStatus";
export const REFRESH = "refresh";

// commercialClientDetails
export const SET_LOCATIONS = "setLocations";
export const SET_LOADING_LOCATIONS = "setLoadingLocations";